import { useTranslation } from 'react-i18next';
import loginHeroBg from '@/assets/images/login-hero.jpg';
import { LoginSeliseLogo } from '../login-selise-logo';
import { LOGIN_COLORS } from '../../constants/login-theme';

export const LoginHeroPanel = () => {
  const { t } = useTranslation();

  return (
    <div className="relative isolate h-full min-h-[calc(100vh-1.5rem)] w-full overflow-hidden rounded-[inherit]">
      <img
        src={loginHeroBg}
        alt=""
        aria-hidden
        className="pointer-events-none absolute inset-[6px] size-full object-fill object-left-top"
      />

      <div className="relative z-10 flex h-full flex-col justify-between p-10">
        <LoginSeliseLogo variant="hero" />

        <div>
          <h1
            className="text-[3rem] font-bold leading-[1.15] tracking-tight"
            style={{ color: LOGIN_COLORS.heroTitle }}
          >
            {t('LOGIN_CAMPAIGN_HEADLINE')}
            <br />
            {t('LOGIN_CAMPAIGN_HEADLINE_ACCENT')}
          </h1>
          <p
            className="mt-2 text-[1.75rem] font-medium leading-10"
            style={{ color: LOGIN_COLORS.heroTagline }}
          >
            {t('LOGIN_CAMPAIGN_TAGLINE')}
          </p>
        </div>
      </div>
    </div>
  );
};
